import { Text } from '@typedream/ui';

function BetaVersion() {
  return (
    <Text variant="secondary" size="2xs">
      Beta Version {process.env.pkgVersion.replace('100', '💯')}
    </Text>
  );
}
export default BetaVersion;
